import React from 'react';

import { ForumPost } from '../../../utils/backend-api/forumPosts';
import ForumPostListItem from '../ForumPostListItem';
import styles from './styles.module.css';

export default function ForumPostList({ forumPosts }: { forumPosts: ForumPost[] }) {
  return (
    <div className={styles.forumPosts}>
      {forumPosts?.map((forumPost) => (
        <ForumPostListItem forumPost={forumPost} key={forumPost.id} />
      ))}
    </div>
  );
}
